import ScalarIconFileMd_vue_vue_type_script_setup_true_lang_default from "./ScalarIconFileMd.vue.script.js";
//#region src/components/ScalarIconFileMd.vue
var ScalarIconFileMd_default = ScalarIconFileMd_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconFileMd_default as default };

//# sourceMappingURL=ScalarIconFileMd.js.map